export default "__VITE_PUBLIC_ASSET__12efdfe9__"